/**
 *
 * FreshPets Radii
 *
 */

const radii = [0, 2, 4, 6, 8, 10, 12, 24, 48]

export default radii
